import React, { useCallback, useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { unitPrice } from '../../../../../../../utils/product'
import Ask from '../../../../components/ask'
import Tool from '../../components/click-open-banner'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import { BigButton } from '../../../../../../components/button'
import { BlackMask } from '../../../../../../components/mask'
import BottomToTop from '../../../../../../components/transitions/bottom-to-top'
import { SensorsTrack } from '../../../../../../utils/sensor'


export const ApplyCash = props => {
    useStyles(classes)

    const { expectedCashDiscount, cashDescription, usedCash, applyCashHandle, onClose } = props
    const [value, setValue] = useState('')
    const [loading, setLoading] = useState(false)


    const applyHandle = async p => {
        if (!loading) {
            setLoading(true)
            await applyCashHandle(p)
            setLoading(false)
            onClose()
        }
    }

    const changeHandle = e => {
        const { value } = e.target
        try {
            if (value > Number(expectedCashDiscount?.amount)) {
                setValue(expectedCashDiscount?.amount)
            } else {
                setValue(value)
            }
        } catch (error) {

        }
    }

    const allHandle = () => {
        setValue(expectedCashDiscount?.amount)
    }

    useEffect(() => {
        setValue(usedCash?.amount || '')
    }, [usedCash])

    return <div className={classes.ApplyPoints}>
        <div className={classes.Hd}>
            <FormattedMessage id="apply_cash" defaultMessage="Apply Cash" />
            <Iconfont className={classes.Close} onClick={onClose}>&#xe7c9;</Iconfont>
        </div>
        <div className={classes.Description}>
            <FormattedMessage id="max_available_count" defaultMessage="Max Available {count}" values={{ count: unitPrice(expectedCashDiscount) }} />
            {' '}
            <Ask content={cashDescription} />
        </div>
        <div className={classes.Bd}>
            <div className={classes.Input}>
                <input type='number' value={value} onChange={changeHandle} />
                <span className={classes.All} onClick={allHandle}>
                    <FormattedMessage id="all" defaultMessage="All" />
                </span>
            </div>
            <BigButton className={classes.Button} disabled={!value} loading={loading} onClick={e => applyHandle(value)}>
                <FormattedMessage id="apply" defaultMessage="Apply" />
            </BigButton>
        </div>
    </div>
}


const ApplyCashEditor = props => {
    useStyles(classes)
    return <React.Fragment>
        <BottomToTop in={props.show} className={classes.ApplyPointsContainer}>
            <div>
                <ApplyCash {...props} />
            </div>
        </BottomToTop>
        {props.show && <BlackMask onClick={props.onClose} />}
    </React.Fragment>
}


export default props => {
    useStyles(classes)
    const { usedCash, cash, cashDescription, expectedCashDiscount, applyCashHandle } = props
    const [show, setShow] = useState(false)

    const clickHandle = useCallback(e => {
        SensorsTrack('PlaceOrderAction', {action: 'ClickWallet'})
        setShow(true)
    }, [])

    const label = usedCash ? <span className={classes.Red}>-{unitPrice(usedCash)}</span> : <>
        <FormattedMessage id="total" defaultMessage="Total" />: {unitPrice(cash)}
    </>

    return <>
        <Tool onClick={clickHandle} value={label}>
            <FormattedMessage id="wallet" defaultMessage="Wallet" /> <Ask content={cashDescription} />
        </Tool>

        <ApplyCashEditor
            show={show}
            onClose={() => setShow(false)}
            expectedCashDiscount={expectedCashDiscount}
            cashDescription={cashDescription}
            usedCash={usedCash}
            applyCashHandle={applyCashHandle} />
    </>
}